"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _gerenciatdUtils = _interopRequireDefault(require("@bit/gerenciatd.utils.front-sonda"));

var _reactRouterScrollMemory = _interopRequireDefault(require("react-router-scroll-memory"));

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.context");

var _gerenciatdUnifiedcomponents = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.stopper"));

var _context = require("./Reducers/context");

var _createRouter = _interopRequireDefault(require("./createRouter"));

var _ErrorBoundary = _interopRequireDefault(require("./ErrorBoundary"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Core extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "componentWillUnmount", () => {
      try {
        const {
          projectId
        } = this.props;
        window.nookInfoExchange.cleanObserver(_gerenciatdUtils2.QUEUE_NAMES.GLOBAL, `MainAppControllerListener-${projectId}-keepContextUpdated`);
      } catch (err) {//
      }
    });

    _defineProperty(this, "componentDidMount", () => {
      const {
        projectId
      } = this.props;
      window.nookInfoExchange.registerAsObserver(_gerenciatdUtils2.QUEUE_NAMES.GLOBAL, `MainAppControllerListener-${projectId}-keepContextUpdated`, context => {
        this.props.setContextData(context);
      }, false); // Lógica testAB

      window.nookInfoExchange.registerAsObserver(_gerenciatdUtils2.QUEUE_NAMES.GLOBAL, `MainAppControllerListener-${projectId}`, context => {
        window.nookInfoExchange.cleanObserver(_gerenciatdUtils2.QUEUE_NAMES.GLOBAL, `MainAppControllerListener-${projectId}`);
        this.setState({
          contextData: context
        }); // enviamos el evento aunque no haga nada

        window.nookInfoExchange.sendMessage('CUSTO_TEST_VERSION', {
          testDisable: true,
          testVersion: '',
          testName: ''
        });
      });
    });

    this.state = {
      contextData: null
    };
  }

  render() {
    const {
      projectId,
      history,
      urlLibrary,
      modulesLibrary,
      defaultErrorScreen,
      inPageError
    } = this.props;
    const {
      contextData
    } = this.state;

    if (!contextData) {
      // fake o algo timeout de error...
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "mainContent xux loading"
      });
    }

    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        id: "mainContent",
        className: "mainContent xux",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_ErrorBoundary.default, {
          history: history,
          projectId: projectId,
          defaultErrorScreen: defaultErrorScreen,
          contextData: contextData,
          children: [inPageError && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
            theme: _gerenciatdUnifiedcomponents.THEMES.EMPTY,
            content: inPageError.errorType,
            contentProps: inPageError.errorInfo,
            projectId: projectId
          }), !inPageError && (0, _createRouter.default)(urlLibrary, modulesLibrary, contextData, projectId)]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterScrollMemory.default, {})]
      })
    });
  }

}

const mapStateToProps = state => ({
  inPageError: state.errorCatcher.inPageError
});

const mapDispatchToProps = dispatch => {
  return {
    setContextData: data => dispatch(_context.actions.setContextData(data))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Core);

exports.default = _default;

//# sourceMappingURL=Core.js.map